module.exports = __webpack_public_path__ + "static/media/web_tech.f87aa75d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web_tech.png
// module id = 384
// module chunks = 0